import {PubSub} from '@mamdev/cad.static-next-lib';

export interface TeaserData {
  teaserElement: HTMLElement;
  teaserIDs: number[];
}

/**
 * Service to load the Video Slideshow module when clicking on a vertical video teaser, in case it hasn't loaded yet.
 */
export class VideoSlideshowLoader {
  private inited = false;
  private videoSlideshowInitialized = false;
  private teaserData: TeaserData;

  /**
   * Inits the service.
   */
  init() {
    try {
      if (this.inited) return;

      console.log('[video-slideshow-loader] init');

      PubSub.subscribeOnce('vertical-video:teaser-clicked', data => {
        // If the video slideshow module was already initialized for whatever reason, no need for this function any longer.
        if (this.videoSlideshowInitialized) return;

        this.teaserData = data as TeaserData;

        console.log('[video-slideshow-loader] initializing video slideshow module...');

        const videoSlideshowModuleRoot = document.querySelector('[data-mod-name="video-slideshow"]');
        videoSlideshowModuleRoot?.removeAttribute('data-mod-bypass');
        videoSlideshowModuleRoot?.setAttribute('data-mod-instant', '');

        PubSub.publish('mod:dynInit', videoSlideshowModuleRoot?.parentElement);
      });

      PubSub.subscribeOnce('video-slideshow:initialized', () => {
        this.videoSlideshowInitialized = true;

        // Pass the data back to the video slideshow module once it's been initialized.
        if (this.teaserData) PubSub.publish('vertical-video:teaser-clicked', this.teaserData);
      });

      this.inited = true;
    } catch (e) {
      PubSub.publish('sentry:log', {
        error: e,
        module: 'video-slideshow-loader'
      });
    }
  }
}
